import React, { useState, useEffect } from "react";
import { CreatableSelect } from "@atlaskit/select";

const HeaderKey = ({ headerKey, onChange, index, headerOptions = [] }) => {
  const [value, setValue] = useState("");

  useEffect(() => {
    if (value !== (headerKey || "")) {
      setValue(headerKey || "");
    }
  }, [headerKey]);

  const onSelect = (selected, event) => {
    if (index < 0) return;
    if (event.action === "clear") {
      setValue("");
      onChange("", index, "KEY");
    } else {
      const val = selected ? selected.value : "";
      onChange(val, index, "KEY");
      setValue(val);
    }
  };
  const handleCreate = (newValue) => {
    if (index < 0) return;
    if (!newValue) return;
    setValue(newValue);
    onChange(newValue, index, "KEY");
  };

  const selectedOption = headerOptions.find((http) => http.value === value) || (value ? { label: value, value } : null);

  return (
    <CreatableSelect
      isClearable
      spacing="compact"
      options={headerOptions}
      value={selectedOption}
      onChange={onSelect}
      onCreateOption={handleCreate}
      className="ihub-headers-select"
      classNamePrefix="header"
    />
  );
};

export default HeaderKey;
